import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PaypalExpressButtonComponentDef } from '@df/module-paypal/paypal-express-button.component.def';
import { Paypal } from '@df/module-paypal/paypal.namespace';
import { ResultComponent } from '../../ui/resut/result.component';
import { LocalGtmService } from '../gtm/gtm.service.decorator';

@Component({
    selector: 'paypal-express-button',
    template: `<div [attr.id]="paypalButtonId"></div>
        @if (status.busy) {
            <div class="w-12 center">
                <i class="icon-loading"></i>
            </div>
        }
        <result [status]="status"></result>`,
    standalone: true,
    imports: [ResultComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaypalExpressButtonComponent extends PaypalExpressButtonComponentDef {
    private gtmService = inject(LocalGtmService);

    protected override onButtonClick(data: Paypal.ISDKButtonOnClickResult): void {
        this.gtmService.push({ event: 'paypalexpress_button_click' });
    }
}
